<div class="flex flex-col gap-[0.25rem]">
  <div *ngIf="title" class="flex flex-row justify-start items-center">
    <label [for]="inputID" class="input-title" [class.red-10]="additionalClass==='error'">
      {{title}}
    </label>
    <span *ngIf="isRequired" class="red-10 line-height-80">*</span>
  </div>
  <div class="control {{additionalClass}}">

    <div class="date-input-container">
      <!-- Text input overlay -->
      <input
        class="formatted-date-input {{additionalClass}}"
        type="text"
        [placeholder]="dateFormat"
        [value]="formattedDate"
        [disabled]="disabled"
        [maxLength]="dateFormat.length"
        (input)="onTextInput($event)"
        (keydown)="restrictInput($event)"
      >

      <!-- Actual date input -->
      <input
        data-qa="date-input"
        [id]="inputID"
        [(ngModel)]="input"
        [min]="minDate"
        [max]="maxDate"
        [type]="'date'"
        [disabled]="disabled"
        (ngModelChange)="onDateInputChange($event)">
    </div>

    <label [for]="inputID" class="control-bottom">{{bottomText}}</label>
  </div>

</div>
